import { toast } from "@/ui-plus/sonner";
import { placeOrderApiClient } from "@api-client/place_order";
import type { ResType } from '@api-client/typeUtils';
import { thermalPrinterFormat } from "@lib/utils/printerFormat";

import { currentPrinter } from "./getPrinters";
import { copies } from "./copiesNumber";
const orderDetailsApiPath = placeOrderApiClient[":storeOrderId"].get_order.$post;
type OrderType = ResType<typeof orderDetailsApiPath>["data"]['order'];

export const LOCALSTORAGE_KEYS = {
    FONT_SIZE_REM: 'FONT_SIZE_REM',
    FONT_WEIGHT: 'FONT_WEIGHT',
}

export const printOrder = (
    orderDetails: OrderType,
    locale: string | undefined = undefined
) => {
    const fontSizeRem = localStorage.hasOwnProperty(LOCALSTORAGE_KEYS.FONT_SIZE_REM) ? Number(localStorage.getItem(LOCALSTORAGE_KEYS.FONT_SIZE_REM)) : 0.8;
    const fontWeight = localStorage.getItem(LOCALSTORAGE_KEYS.FONT_WEIGHT) as 'normal' | 'bold' ?? 'normal';
    const html = thermalPrinterFormat(orderDetails, locale, fontSizeRem, fontWeight);
    printHTML(html, currentPrinter.value?.deviceName || '', copies.value || 1);
}

export const printHTML = async function (
    html: string,
    _printer: string,
    copies: number = 1,
) {
    // Set up load event before appending to DOM
    return new Promise(resolve => {
        // TODO: check if printer is in the list of printers, maybe we should report it sender store email.



        const styles = document.querySelectorAll('style');
        styles.forEach(style => {
            style.remove();
        });

        const links = document.querySelectorAll('link[rel="stylesheet"]');
        links.forEach(link => {
            link.remove();
        });

        const app = document.getElementById('app');
        if (!app) {
            return;
        }
        const oldDisplay = app.style.display;
        app.style.display = 'none';

        // Create a style to hide everything except our iframe
        const hideAllStyle = document.createElement('style');
        hideAllStyle.id = 'print-hide-all';
        hideAllStyle.textContent = `
            body > *:not(iframe[data-print-iframe]) {
                display: none !important;
            }
        `;
        document.head.appendChild(hideAllStyle);

        const iframe = document.createElement("iframe");
        iframe.setAttribute('data-print-iframe', 'true');
        // Set iframe properties before appending to body
        iframe.style.width = "100%";
        iframe.style.height = "100%";
        iframe.style.border = "none";
        iframe.style.position = "fixed";
        iframe.style.top = "0";
        iframe.style.left = "0";
        iframe.style.zIndex = "916000020";
        iframe.style.visibility = "hidden";

        // Use blob URL instead of direct writing for better loading behavior
        const blob = new Blob([html], { type: 'text/html' });
        const url = URL.createObjectURL(blob);
        iframe.src = url;

        iframe.onload = async () => {
            // Show iframe once loaded
            iframe.style.visibility = "visible";

            // Small delay to ensure rendering is complete
            await new Promise(resolve => setTimeout(resolve, 200));
            // Get iframe's window reference again after it's loaded
            const iframeWindow = iframe.contentWindow;
            if (!iframeWindow) {
                console.error("Could not access iframe's window");
                return;
            }
            toast.message(`simulating print... ${copies} copies`);
            for (let i = 0; i < copies; i++) {
                await new Promise(resolve => setTimeout(resolve, 800));
                iframeWindow.print();
            }
            await new Promise(resolve => setTimeout(resolve, 500));
            document.body.removeChild(iframe);
            URL.revokeObjectURL(url); // Clean up the blob URL

            // Remove the hiding style
            const hideAllStyle = document.getElementById('print-hide-all');
            if (hideAllStyle) {
                hideAllStyle.remove();
            }

            app.style.display = oldDisplay;
            // document.head.appendChild(style);
            styles.forEach(style => {
                document.head.appendChild(style);
            });
            links.forEach(link => {
                document.head.appendChild(link);
            });
            resolve(true);
        };

        // Append to body after setup is complete
        document.body.appendChild(iframe);
    });
};